// @ts-expect-error - commonjs module
import { useRegisterSW } from 'virtual:pwa-register/react'
import { useEffect } from 'react'
import { createLogger } from 'v2/utils/logger'
import type { RegisterSWOptions } from 'vite-plugin-pwa/types'
import { type SonnerConfig, sonnerManager } from '../utils/sonner-manager'

const logger = createLogger('Update Modal')

export const UpdateHandler = () => {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, r) {
      logger.local('Service Worker registered', { swUrl })
      if (r?.update) {
        logger.debug('Starting interval to check for updates')
        setInterval(() => {
          r?.update()
        }, 10000) // 10 seconds
      }
    },
    onRegisterError(error) {
      logger.error('Service Worker registration failed', { error })
    },
  } as RegisterSWOptions)

  useEffect(() => {
    const updateToastConfig: SonnerConfig = {
      id: 'update',
      type: 'info',
      title: 'New version available',
      description: 'Please reload this window now to update.',
      action: {
        onClick: () => updateServiceWorker(true),
        label: 'Reload',
      },
      onClose: () => setNeedRefresh(false),
    }
    sonnerManager.showToast(updateToastConfig, needRefresh)
  }, [needRefresh, updateServiceWorker, setNeedRefresh])

  return null
}
